import { z } from 'zod';
import { compactBooleanFilterSchema } from '@/common/zod-schemas/common/compactFilterSchemas';

export const capacitySearchSchema = z.object({
  q: z.string().optional(),
  showArchived: compactBooleanFilterSchema,
});

export type CapacitySearchParams = z.output<typeof capacitySearchSchema>;
